import {
  Alert,
  Button,
  FormGroup,
  Link,
  Loader,
  NavigationBar,
  NavigationContent,
} from 'arag-ui-lib'
import {
  LEGAL_ADVICE_TEXT,
} from '../../helpers/variables'
import StagedStep1 from './WizardSteps/stagedStep1'
import StagedStep2 from './WizardSteps/stagedStep2'
import StagedStep3 from './WizardSteps/stagedStep3'
import StagedStep4 from './WizardSteps/stagedStep4'
const steps = [
  { label: 'Commissions', key: '1' },
  { label: 'Premiums & LOI', key: '2' },
  { label: 'Notes & Coverage', key: '3' },
  { label: 'Overview', key: '4' },
]
const StagedPremiumSettingsWizard = (props) => {
  const {
    stagedPremiumSettingsWizard,
    stagedSubSettings,
    formIsFetching,
    changeStageSubSetting,
    agentsList,
    premiumSettings,
    currentStep,
    nextStep,
    previousStep,
    workSourceName,
    isApplicationPremium,
    toggleCommissionModal,
    commissionModal,
    lawsysFirms,
    onSuggestionChange,
    onSuggestionSelected,
    changeStagedPremiumFormData,
    addCommission,
    removeSolicitor,
    displayDataPerStage,
    onCancel,
  } = props

  const continueButtonText = currentStep == 4 ? 'Submit' : 'Next step'
  const continueButton =
    currentStep == 4 ? () => props.handleSubmit() : () => nextStep()
  const disableButtons =
    stagedPremiumSettingsWizard.posting || stagedPremiumSettingsWizard.patching;

  const goingLiveLoading =
    (stagedPremiumSettingsWizard.fetchingStagedPremium ||
      stagedPremiumSettingsWizard.fetchingCoverageTypes ||
      stagedPremiumSettingsWizard.fetchingStages ||
      premiumSettings.fetchingPremiumWithCombination ||
      stagedPremiumSettingsWizard.fetching ||
      premiumSettings.fetching ||
      premiumSettings.fetchingPremiumSettingById ||
      stagedPremiumSettingsWizard.changingApplicationStatus) &&
    !stagedPremiumSettingsWizard.patching;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault()
        continueButton()
      }}
    >
      {isApplicationPremium == false && (
        <h2 className='solicitor-form-title'>
          {props.isEdit ? (
            <span>Edit Staged Premium Setting</span>
          ) : (
            <span>New Staged Premium Setting</span>
          )}
        </h2>
      )}
      {isApplicationPremium == true && (
        <h3>Application Premium Settings</h3>
      )}
      {premiumSettings.selectedSolicitorGroupName ? (
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={`${LEGAL_ADVICE_TEXT} group`}
          variant={'plain'}
          inputProps={{
            label: premiumSettings.selectedSolicitorGroupName,
          }}
        />
      ) : null}
      {workSourceName && isApplicationPremium == false ? (
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Work source'}
          variant={'plain'}
          inputProps={{
            label: workSourceName,
          }}
        />
      ) : null}
      {props.caseTypeName && isApplicationPremium == false ? (
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Case type'}
          variant={'plain'}
          inputProps={{
            label: props.caseTypeName,
          }}
        />
      ) : null}
      {props.subCaseTypeName && isApplicationPremium == false ? (
        <FormGroup
          labelSize={'col-sm-2'}
          inputSize={'col-sm-6'}
          label={'Sub case type'}
          variant={'plain'}
          inputProps={{
            label: props.subCaseTypeName,
          }}
        />
      ) : null}
      <NavigationBar
        onNavItemSelect={() => null}
        activeItemKey={currentStep.toString()}
        variant='wizard'
        stepCounter
        navItems={steps}
      />
      {formIsFetching == true && (
        <div className='col-sm-12'>
          <Loader variant='list' />
        </div>
      )}
      {currentStep == 1 && formIsFetching == false && (
        <NavigationContent>
          <StagedStep1
            agentsList={agentsList}
            changeStagedPremiumFormData={changeStagedPremiumFormData}
            lawsysFirms={lawsysFirms}
            toggleCommissionModal={toggleCommissionModal}
            commissionModal={commissionModal}
            onSuggestionSelected={onSuggestionSelected}
            onSuggestionChange={onSuggestionChange}
            stagedPremiumsWizard={stagedPremiumSettingsWizard}
            addCommission={addCommission}
            removeSolicitor={removeSolicitor}
          />
        </NavigationContent>
      )}
      {currentStep == 2 && formIsFetching == false && (
        <NavigationContent>
          <StagedStep2
            agentsList={agentsList}
            stagedSubSettings={stagedSubSettings}
            amountColumnsDisplayDataPerStage={displayDataPerStage}
            stagedPremiumsWizard={stagedPremiumSettingsWizard}
            changeStageSubSetting={changeStageSubSetting}
            changeStagedPremiumFormData={changeStagedPremiumFormData}
          />
        </NavigationContent>
      )}
      {currentStep == 3 && formIsFetching == false && (
        <NavigationContent>
          <StagedStep3
            isApplicationPremium={isApplicationPremium}
            changeStagedPremiumFormData={changeStagedPremiumFormData}
            stagedPremiumsWizard={stagedPremiumSettingsWizard}
          />
        </NavigationContent>
      )}
      {currentStep == 4 && formIsFetching == false && (
        <NavigationContent>
          <StagedStep4
            amountColumnsDisplayDataPerStage={displayDataPerStage}
            isApplicationPremium={isApplicationPremium}
            stagesSubSettings={stagedSubSettings}
            stagedPremiumData={stagedPremiumSettingsWizard}
          />
        </NavigationContent>
      )}
      {/* next/back/cancel buttons */}
      {formIsFetching == false && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            padding: 10,
          }}
        >
          {(disableButtons || goingLiveLoading) && (
            <div style={{ paddingRight: 10 }}>
              <Loader />
            </div>
          )}

          <div style={{ maxHeight: 34, paddingRight: 10 }}>
            <Button
              variant='quaternary'
              label='Back'
              disabled={currentStep <= 1 || disableButtons || goingLiveLoading}
              onClick={previousStep}
            />
          </div>

          <Button
            variant='primary'
            type={'submit'}
            label={continueButtonText}
            arrowDirection='right'
            disabled={
              props.currentStep > 4 || disableButtons || goingLiveLoading
            }
          />
        </div>
      )}
      {formIsFetching == false && (
        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
          }}
        >
          <Link
            variant='tertiary'
            arrowDirection='left'
            label='Cancel'
            disabled={disableButtons || goingLiveLoading}
            onClick={onCancel}
          />
        </div>
      )}
      {stagedPremiumSettingsWizard.errorResponse?.length > 0 && (
        <div className='col-sm-12'>
          <Alert
            variant='error'
            label={stagedPremiumSettingsWizard.errorResponse}
            onDismiss={() =>
              props.changeStagedPremiumFormData('errorResponse', '')
            }
          />
        </div>
      )}
      {stagedPremiumSettingsWizard.successMessage?.length > 0 && (
        <div className='col-sm-12'>
          <Alert
            variant='success'
            label={stagedPremiumSettingsWizard.successMessage}
          />
        </div>
      )}
    </form>
  )
}
export default StagedPremiumSettingsWizard
